"use client"

import { Button, ButtonProps } from "../ui/button"
import { Translate } from "../ui/translate"

export function BaseCloseButton(props: ButtonProps) {
  return (
    <Button {...props} variant="ghost">
      <Translate i18nKey="SiteHeader.closeBtn" />
    </Button>
  )
}
